<template>
  <template v-if="progress < 100">
    <div class="farming-button">
      <div class="farming-fill" :style="{ width: `${progress}%` }"></div>
      <div class="farming-text">Farming <Balance :balance="balanceString" /> <IconLP /></div>
      <div class="farming-time">{{ timeString }}</div>
    </div>
  </template>
  <template v-else>
    <div class="farming-button complete" @click="emit('claim')">
      <div class="farming-text claim">Claim <Balance :balance="balanceString" /> <IconLP /></div>
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import IconLP from '@/components/Icons/IconLP.vue'
import Balance from '@/components/Balance.vue'
const props = defineProps(['farming'])
const emit = defineEmits(['claim'])
let intervalId: number

const endDate = new Date(props.farming.ends_at).getTime()
const startDate = new Date(props.farming.started_at).getTime()
const duration = endDate - startDate
const timeString = ref('00h 00m')
const progress = ref(0)
const total = 200
const current = ref(4.3)
const balanceString = computed(() => current.value.toFixed(2).padStart(6, '0'))
const updateCountdown = () => {
  const now = new Date().getTime()
  const difference = endDate - now

  if (difference <= 0) {
    progress.value = 100
    current.value = total
    clearInterval(intervalId)
    return
  }
  const percentage = Math.max(1 - difference / duration, 0)
  progress.value = percentage * 100

  current.value = total * percentage

  const hours = Math.floor(difference / (1000 * 60 * 60))
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')

  timeString.value = `${formattedHours}h ${formattedMinutes}m`
}

updateCountdown()
intervalId = window.setInterval(updateCountdown, 500)
</script>

<style lang="scss">
.farming-button {
  height: 50px;
  background-color: rgb(167, 167, 167);
  border-radius: 15px;
  position: fixed;
  bottom: 100px;
  left: 20px;
  width: calc(100vw - 40px);
  overflow: hidden;
  border: 1px solid lightgray;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.64px;
  .farming-fill {
    width: 20px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--blue-color);
  }
  &::before {
    content: '';
    position: absolute;
    left: 1px;
    top: 1px;

    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background-color: lightgray;
    z-index: 1;
    border-radius: 13px;
  }
  .farming-time {
    position: absolute;
    right: 15px;
    bottom: 10px;
    font-family: 'Forma DJR Display';
    font-size: 12px;
    z-index: 2;
  }

  .farming-text {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-family: 'Roboto Mono';
    .icon {
      fill: var(--black-color);
      height: 20px;
      width: 20px;
    }
    &.claim .icon {
      fill: white;
    }
  }

  &.complete {
    background-color: var(--blue-color);
    color: white;
    &::before {
      display: none;
    }
  }
}
</style>
